import React, { Component } from 'react';
import './Home.css';

export default class Home extends Component {
    constructor() {
        super();
        this.state = {};
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col">
                        <div className="profile_photo">
                            <img src="./../images/profile.jpg" style={{ width: "200px", height: "200px" }} alt="" />
                        </div>

                        <div className='category_title'>
                            WORK EXPERIENCE
                        </div>
                        <div className='profile_desc'>
                            <div className="desc_block">
                                <div>
                                    <i class="fa fa-briefcase" aria-hidden="true"></i> Senior Software Engineer, Symantec Corporation
                                </div>
                                <div>
                                    <i class="fa fa-calendar" aria-hidden="true"></i> 2015 - Current
                                </div>
                            </div>
                            <div className="desc_block">
                                <div>
                                    <i class="fa fa-briefcase" aria-hidden="true"></i> Project Engineer, Wipro Limited
                                </div>
                                <div>
                                    <i class="fa fa-calendar" aria-hidden="true"></i> 2011 - 2013
                                </div>
                            </div>
                        </div>

                        <div className='category_title'>
                            ACADEMICS
                        </div>
                        <div className='profile_desc'>
                            <div className="desc_block">
                                <div>
                                    <i class="fa fa-university" aria-hidden="true"></i>  University of Texas at Dallas
                                    <div>
                                        <i class="fa fa-book" aria-hidden="true"></i> Master of Science in Computer Science
                                    </div>
                                </div>
                                <div>
                                    <i class="fa fa-calendar" aria-hidden="true"></i> 2013 - 2015
                                </div>
                            </div>
                            <div className="desc_block">
                                <div>
                                    <i class="fa fa-university" aria-hidden="true"></i>  St.Joseph's college of Engineering
                                    <div>
                                        <i class="fa fa-book" aria-hidden="true"></i> Bachelor's of Engineering in Computer Science
                                    </div>
                                </div>
                                <div>
                                    <i class="fa fa-calendar" aria-hidden="true"></i> 2007 - 2011
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        
                        <div className='category_title'>
                            SOCIAL NETWORKS
                        </div>
                        <div className="desc_block">
                            <span>
                                <i class="fa fa-twitter" aria-hidden="true"></i>
                            </span>
                            <span>
                                <a href="https://twitter.com/senthilmpro" target="_blank" rel="noopener noreferrer"> Twitter</a>
                            </span>
                        </div>
                        <div className="desc_block">
                            <span>
                                <i class="fa fa-github" aria-hidden="true"></i>
                            </span>
                            <span>
                                <a href="https://github.com/senthilmpro" target="_blank" rel="noopener noreferrer"> Github</a>
                            </span>
                        </div>
                        <div className="desc_block">
                            <span>
                                <i class="fa fa-linkedin" aria-hidden="true"></i>
                            </span>
                            <span>
                                <a href="https://www.linkedin.com/in/senthilmpro/" target="_blank" rel="noopener noreferrer"> Linkedin</a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}